import React, { useState, useContext, useEffect } from 'react'
import UploadSection from '../../../../components/molecules/UploadSection/UploadSection'
import Button from '../../../../components/atoms/Button'
import styles from './mrOnboarding.module.scss'
import historyIcon from '../../../../assets/img/history.png'
import FileStatus from '../../../../components/molecules/FileStatus/FileStatus'
import SampleFileModal from '../../../../components/atoms/SampleFileModal/SampleFileModal'
import { NotifierContext } from '../../../../context/NotifierContext'
import { getPresignedURL, uploadFile, getSampleFilePresignedURL, getUploadStatus, getDownLoadProcessedResultUrl } from '../../../../services/api/tcAuditService'
import { useHistory } from 'react-router-dom'
import RefreshButton from '../../../../components/atoms/RefreshButton/RefreshButton'
import InfoModal from '../../../../components/atoms/Modal/Modal'

// import LoadMoreButton from '../../../../components/atoms/LoadMoreButton/LoadMoreButton'

const MrOnboarding = ({ selectedFile }) => {
  const [sampleFileOpen, setSampleFileOpen] = useState(false)
  const [sampleFileLoader, setSampleFileLoader] = useState(false)
  const { notifyError, notifySuccess } = useContext(NotifierContext)
  const [filUploadLoader, setFileUploadLoader] = useState(false)
  const [loading, setLoading] = useState(true)
  const [processedResultLoader, setProcessedResultLoader] = useState(false)
  const [filesHistory, setFilesHistory] = useState([])
  const [modalVisible, setModalVisibility] = useState(false)

  // const [pageData, setPageData] = useState({
  //   current: 1,
  //   last: 1
  // })

  const history = useHistory()

  useEffect(() => {
    fetchFileUploadStatus(1)
  }, [])

  const fetchFileUploadStatus = async (page) => {
    try {
      setLoading(true)
      const response = await getUploadStatus({
        fileCategory: 'users',
        page,
        perPage: 1,
        sortBy: 'uploadDate',
        uploadedBy: 'AE'
      })
      if (page === 1) {
        setFilesHistory(response.data.fileHistory)
      } else {
        setFilesHistory([...filesHistory, ...response.data.fileHistory])
      }
      // setPageData(response.data.pageData)
    } catch (error) {
      notifyError(error)
    } finally {
      setLoading(false)
    }
  }

  const handleSampleFileDownload = async () => {
    try {
      setSampleFileLoader(true)
      const response = await getSampleFilePresignedURL('users')
      setSampleFileOpen(false)
      notifySuccess('File download has started...')
      window.location.href = response.data
    } catch (err) {
      notifyError(err)
    } finally {
      setSampleFileLoader(false)
    }
  }

  const handleFileUploading = async (event) => {
    try {
      setFileUploadLoader(true)
      const fileExtension = event.target.files[0].name.split('.').pop()

      if (fileExtension !== 'xlsx' && fileExtension !== 'xlsb' && fileExtension !== 'xls') {
        throw new Error('This type of file is not allowed to upload. You can upload only files which have xls,xlsx,xlsb extensions')
      }

      const response = await getPresignedURL('users')
      await uploadFile(event.target.files[0], response.data[fileExtension])
      notifySuccess('Successfully Uploaded the MR onboarding file.')
    } catch (err) {
      notifyError(err)
    } finally {
      setFileUploadLoader(false)
    }
  }

  // const handleLoadMore = () => {
  //   const nextPage = pageData.current + 1
  //   fetchFileUploadStatus(nextPage)
  // }

  const handleProcessingResultDownload = async (fileId, failureFile) => {
    try {
      setProcessedResultLoader(fileId)
      const response = await getDownLoadProcessedResultUrl('users', fileId, failureFile)
      window.location.href = response.data
    } catch (error) {
      notifyError(error)
    } finally {
      setProcessedResultLoader(false)
    }
  }

  return (
    <div className='container'>
      <UploadSection
        fileName={selectedFile.name}
        hasSampleFile hasAuditMonth={false}
        sampleFileHandler={() => setSampleFileOpen(true)}
        handleFileUpload={handleFileUploading}
        fileUploadDisabled={filUploadLoader}
      />
      <div className='d-flex align-items-center justify-content-between mt-5 my-4'>
        <div className={styles.heading}>
          Latest file upload status (uploaded by me)
        </div>
        <RefreshButton
          onRefresh={() => { fetchFileUploadStatus(1) }}
          loading={loading}

        />
      </div>
      {loading
        ? <div>Loading....</div>
        : filesHistory.length === 0
          ? <div>No results found!</div>
          : (
            <>
              {filesHistory.map((file, index) => {
                return (
                  <div className={styles.fileStatusContainer} key={file.fileId}>
                    <FileStatus
                      index={index + 1}
                      status={file.status}
                      fileId={file.fileId}
                      hasErrorResult
                      uploadedOn={file.uploadedOn}
                      message={file.message}
                      onProcessingResultDownload={(failureFile) => { handleProcessingResultDownload(file.fileId, failureFile) }}
                      disableProcessedResult={processedResultLoader === file.fileId}
                      count={{
                        success: file.count?.success ?? '-',
                        failure: file.count?.failure ?? '-',
                        skipped: file.count?.skipped ?? '-'
                      }}
                      onClickFailureRows={() => setModalVisibility('failure')}
                      onClickSkippedRows={() => setModalVisibility('skipped')}
                    />
                  </div>
                )
              })}
              {/* {!(pageData.current === pageData.last) &&
                <LoadMoreButton onClick={handleLoadMore} />} */}
            </>
            )}
      <div className={`${styles['btn-container']} mt-5`}>
        <Button
          className={`btn btn-light ${styles['upload-history-btn']}`}
          onClick={() => {
            history.push('/file-upload?tab=mrOnboardingFileHistory')
          }}
        >
          View file upload history
          <img src={historyIcon} alt={styles['history-icon']} />
        </Button>
      </div>
      <SampleFileModal
        okBtnDisabled={sampleFileLoader}
        open={sampleFileOpen}
        heading='Instructions - MR Onboarding'
        onClose={() => setSampleFileOpen(false)}
        onSubmit={handleSampleFileDownload}
      >
        <h3>
          General instructions
        </h3>

        <div>1. * in a column heading states that field is required and can not be skipped</div>
        <br />
        <h3>
          User specific instructions
        </h3>
        <h3>MR</h3>
        <div>1. MR_code and First_name are required</div>
        <br />
        <h3>Updating a user</h3>
        1. Once a user has been added the only fields that are allowed to be updated are First_name, Last_name and Phone_number
        <div />

      </SampleFileModal>
      <InfoModal
        title={`Possible reasons for ${modalVisible} rows`}
        visible={modalVisible}
        onModalClose={() => setModalVisibility(false)}
        hideFooter
      >
        {modalVisible === 'failure' &&
          (
            <>
              1. When the parent is not found
              <br />
              {'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}Eg - They are trying to create an AEE whose parent EE does not exist
              <br /><br />
              2. When the user provides a duplicate phone number
              <br /> <br />
              3. For a MR, if the MR code does not begin with the sub-division code, it goes to failure state
              <br /> <br />
            </>
          )}
        {modalVisible === 'skipped' &&
          <>
            1. Rows are skipped when there are duplicate rows i.e., when a code for the given designation is already present
            <br /><br />
            2. Rows are skipped when the user is already present in the system and there are no changes in the editable columns for that user
            <br /><br />
            3. When an AE has uploaded the file and is trying to create MR for other sections
            <br /> <br />
          </>}
      </InfoModal>
    </div>
  )
}

export default MrOnboarding
